import { customCellIdentifierRenames } from './custom-cell-identifier-renames.js'

export function replaceCustomCellIdentifier(text: string, before: string, after: string): string {
  const match = customCellIdentifierRenames(before, after).find(([from]) => text === from)
  return match ? match[1] : text
}
